import isPresent from "utils/isPresent";

export default function getIsThisYouLabel({ firstName, lastName }) {
  if (isPresent(firstName) && isPresent(lastName)) {
    return `Are you ${firstName} ${lastName}?`;
  }

  return "Is this you?";
}
